import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import ScrollableContainer from 'src/components/BeaconV2Components/ScrollableContainer';
import {
  SlDialog,
  SlDialogCloseButton,
  SlDialogContent,
  SlDialogFooter,
  SlDialogHeader,
  SlDialogRoot,
  SlDialogTitle
} from 'src/components/BeaconV2Components/SlDialog';
import { Definition } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/components/VoiceAndTone/VoiceAndTonePagePopup';
import color from 'src/utils/colors';

interface BaseDefinitionsPopupProps {
  open: boolean;
  onClose: () => void;
  title: string;
  definitions: Array<{ name: string; description: string }>;
}

export const BaseDefinitionsPopup = ({ open, onClose, title, definitions }: BaseDefinitionsPopupProps) => {
  return (
    <SlDialogRoot>
      <SlDialog onClose={onClose} open={open} width={752} height={641}>
        <SlDialogHeader>
          <SlDialogTitle>{title}</SlDialogTitle>
          <SlDialogCloseButton onClick={onClose} />
        </SlDialogHeader>

        <ScrollableContainer scrollbarWidth="5px" thumbColor={color.blueGrey}>
          <SlDialogContent sx={{ overflowX: 'hidden', paddingX: '48px' }}>
            <Flex flexDirection="column" sx={{ gap: '24px' }}>
              {definitions.map((definition) => (
                <Definition key={definition.name} {...definition} />
              ))}
            </Flex>
          </SlDialogContent>
        </ScrollableContainer>

        <SlDialogFooter
          sx={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <Flex justifyContent="center">
            <SlButton onClick={onClose}>Close</SlButton>
          </Flex>
        </SlDialogFooter>
      </SlDialog>
    </SlDialogRoot>
  );
};
